import { render, staticRenderFns } from "./PaymentReturnModal.vue?vue&type=template&id=c14cd4a6"
import script from "./PaymentReturnModal.vue?vue&type=script&lang=js"
export * from "./PaymentReturnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports